<mat-nav-list data-testid="top-level-side-nav-container">
  @if ((userIsLoggedIn$ | async)) {
    @if ((activeUser$ | async)) {
      <app-admin-nav></app-admin-nav>
    }
  } @else {
    <mat-list-item routerLink="/auth/login">
      <mat-icon matListItemIcon>login</mat-icon>
      <div matLine data-testid="sidenav-login">Log in</div>
    </mat-list-item>
  }
</mat-nav-list>
